import React from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Modal,
  notification,
  DatePicker,
  Typography,
  InputNumber,
  Button,
  Select
} from "antd";

import axiosInstance from "../../../utilities/axios";
import ConditionSwitcher from 'pages/Discounts/components/ApplicabilityLogic';
import { useWatch } from 'antd/es/form/Form';

const { Title } = Typography;

const NewMarkupModal = ({ onChange, onClose, visible }) => {
  const [form] = Form.useForm();
  const type = useWatch("valueType", form);

  const onSubmit = (values) => {
    axiosInstance
      .post("/markups", values)
      .then(() => {
        onChange();
        form.resetFields();
        onClose();
        notification.success({
          message: "Success",
          description: "Markup created successfully",
        });
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: error.message,
        });
      });
  };

  return (
    <Modal
      title="New Markup"
      open={visible}
      onCancel={() => {
        onClose();
        form.resetFields();
      }}
      width={800}
      footer={[]}
      styles={{
        content: {
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 200px)'
        } 
      }}
    >
      <Form
        form={form}
        name="newMarkupForm"
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          label="Markup Name"
          name="markupName"
          rules={[{ required: true, message: 'Please input the markup name' }]}
        >
          <Input placeholder='Enter Markup Name' />
        </Form.Item>
        <Form.Item
          label="Value Type"
          name="valueType"
          rules={[{ required: true, message: "Please select a value type"}]}
        >
          <Select
            placeholder="Select Value Type"
            options={[
              { label: "Percentage", value: "percentage" },
              { label: "Fixed", value: "fixed" }
            ]}
            defaultValue="fixed"
          />
        </Form.Item>
        <Form.Item
          label="Markup Value"
          name='markupValue'
          rules={[
            { required: true, message: "Please input a markup value" },
            { type: 'number', min: 0, message: "Markup value must be a positive number" },
          ]}
        >
          <InputNumber
            placeholder="Enter Markup Value"
            style={{ width: "100%" }}
            prefix={type === "fixed" ? "$" : null}
            suffix={type === "percentage" ? "%" : null}
          />
        </Form.Item>
        <Row gutter={16} style={{ marginBottom: 0 }}>
          <Col span={12}>
            <Form.Item
              label="Effective Date"
              name="effectiveDate"
              rules={[{ required: true, message: "Please input an effective date" }]}
              style={{ marginBottom: 0 }}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Expiration Date"
              name="expirationDate"
              style={{ marginBottom: 0 }}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Title level={5} style={{ marginTop: "24px" }}>
          Applicability Rules
        </Title>
        <Form.Item name="logic" style={{ marginBottom: 24 }}>
          <ConditionSwitcher />
        </Form.Item>
        <Button
          type="primary"
          htmlType='submit'
          block
        >
          Add Markup
        </Button>
      </Form>
    </Modal>
  );
};

export default NewMarkupModal;